<div class="p-2 badge rounded-pill bg-{{ styles[priorita] }}" >
  {{ priorita}}
</div>